/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';
import {
  ArrowDownCircleIcon,
  ArrowUpCircleIcon,
} from '@heroicons/react/24/solid';
import { formatDateToLocal, withErrorBoundary } from '@navi-app/utils';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { ProgressSteps, Step, StyledContentTail } from 'baseui/progress-steps';
import {
  LabelMedium,
  LabelSmall,
  ParagraphSmall,
  ParagraphXSmall,
} from 'baseui/typography';
import { TFunction } from 'i18next';
import { memo, useState } from 'react';
import Tag from '../lib/tag';

export type DynamicObject = {
  [name: string]: any;
};

type TLocationLogSteps = {
  t: TFunction;
  data: DynamicObject[] | undefined;
  podFiles?: DynamicObject[];
  isPhoneSize?: boolean;
  showIconExpand?: boolean;
  showTag?: boolean;
  showLoadDateAndCity?: boolean;
  showDocument?: boolean;
  openModal: (value: string, data?: any) => void;
  loadUnloadDate?: DynamicObject;
  titleSmall?: boolean;
  addressXSmall?: boolean;
  customMaxWidth?: string;
};

export const ContainerIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#1E64DC" />
    <path
      d="M13.3337 7.90059V7.60059H2.66699V7.90059H2.91423V11.2673H2.66699V11.5673H13.2983V11.2673H13.0511V7.90059H13.3337ZM4.53896 10.9673H3.86788V8.16725H4.53896V10.9673ZM6.44624 10.9673H5.77516V8.16725H6.44624V10.9673ZM8.35353 10.9673H7.64712V8.16725H8.35353V10.9673ZM10.2255 10.9673H9.55441V8.16725H10.2255V10.9673ZM12.1328 10.9673H11.4617V8.16725H12.1328V10.9673Z"
      fill="white"
    />
    <path
      d="M3.5121 8.00059L3.33398 7.73392L8.00065 4.60061L12.6673 7.73392L12.4892 8.00059L8.00065 5.00061L3.5121 8.00059Z"
      fill="white"
    />
    <path
      d="M7.93359 5.46745C7.36838 5.46745 6.93359 5.13411 6.93359 4.70078V4.20078H7.36838V4.70078C7.36838 4.93411 7.62925 5.13411 7.93359 5.13411C8.23794 5.13411 8.49881 4.93411 8.49881 4.70078V3.30078H8.93359V4.70078C8.93359 5.13411 8.49881 5.46745 7.93359 5.46745Z"
      fill="white"
    />
    <path
      d="M9.06173 3.40033H8.27161C8.12346 3.40033 8 3.23366 8 3.03366C8 2.83366 8.12346 2.66699 8.27161 2.66699H9.06173C9.20988 2.66699 9.33333 2.83366 9.33333 3.03366C9.33333 3.26699 9.20988 3.40033 9.06173 3.40033Z"
      fill="white"
    />
  </svg>
);
export const IconLoad = () => <ArrowUpCircleIcon className="w-6 h-6" />;
export const IconUnload = () => (
  <ArrowDownCircleIcon className="w-6 h-6 text-[#1E64DC]" />
);
export const AirportIcon = ({ type }: { type?: 'load' | 'unload' }) => {
  const fill = type === 'load' ? 'black' : '#1E64DC';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_494_113230)">
        <path
          d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z"
          fill={fill}
        />
        <path
          d="M7.09649 12L6.01156 9.98356L3.99512 8.89863L4.7732 8.13151L6.36224 8.40548L7.48005 7.28767L4.00608 5.80822L4.92662 4.86575L9.1458 5.61096L10.5047 4.25205C10.6727 4.08402 10.881 4 11.1294 4C11.3778 4 11.586 4.08402 11.754 4.25205C11.9221 4.42009 12.0061 4.62648 12.0061 4.87123C12.0061 5.11598 11.9221 5.32237 11.754 5.49041L10.3842 6.86027L11.1294 11.0685L10.1979 12L8.70745 8.52603L7.58964 9.64384L7.87457 11.2219L7.09649 12Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_494_113230">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PortIcon = ({ type }: { type?: 'load' | 'unload' }) => {
  const fill = type === 'load' ? 'black' : '#1E64DC';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_494_112355)">
        <path
          d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z"
          fill={fill}
        />
        <path
          d="M7.86089 3.83344C7.74978 3.86122 7.63867 3.889 7.52756 3.94455C7.11089 4.139 6.88867 4.47233 6.88867 4.94455C6.88867 5.41677 7.11089 5.75011 7.52756 5.97233C7.58312 6.00011 7.58312 6.02789 7.58312 6.05566C7.58312 6.139 7.58312 6.25011 7.58312 6.36122C7.55534 6.36122 7.49978 6.36122 7.47201 6.36122C7.11089 6.36122 6.74978 6.36122 6.38867 6.36122C6.22201 6.36122 6.19423 6.41677 6.19423 6.55566C6.19423 6.69455 6.19423 6.86122 6.19423 7.00011C6.19423 7.139 6.24978 7.19455 6.38867 7.19455C6.74978 7.19455 7.13867 7.19455 7.49978 7.19455C7.52756 7.19455 7.55534 7.19455 7.58312 7.19455C7.58312 8.389 7.58312 9.58344 7.58312 10.7779C7.13867 10.6946 6.74978 10.5279 6.38867 10.2501C6.02756 9.97233 5.80534 9.61122 5.69423 9.139C5.77756 9.139 5.83312 9.139 5.88867 9.139C5.94423 9.139 5.99978 9.11122 6.02756 9.05566C6.05534 9.00011 6.05534 8.94455 5.99978 8.889C5.77756 8.61122 5.55534 8.36122 5.33312 8.08344C5.24978 7.97233 5.16645 8.00011 5.08312 8.08344C4.86089 8.33344 4.63867 8.61122 4.41645 8.86122C4.36089 8.91677 4.36089 8.97233 4.38867 9.02789C4.41645 9.11122 4.472 9.11122 4.55534 9.11122C4.63867 9.11122 4.74978 9.11122 4.83312 9.11122C5.16645 10.5834 6.16645 11.3334 7.58312 11.6112C7.58312 11.6112 7.58312 11.6112 7.58312 11.639C7.55534 11.7779 7.63867 11.889 7.72201 11.9723C7.77756 12.0279 7.83312 12.0834 7.88867 12.139C7.97201 12.1946 8.02756 12.1946 8.11089 12.139C8.19423 12.0557 8.30534 11.9723 8.36089 11.8612C8.38867 11.8334 8.41645 11.7501 8.41645 11.6946C8.41645 11.6112 8.44423 11.5834 8.52756 11.5557C8.99978 11.5001 9.41645 11.3334 9.83312 11.0834C10.5276 10.639 10.9998 10.0001 11.1664 9.19455C11.1664 9.16677 11.1664 9.139 11.1942 9.11122C11.2776 9.11122 11.3609 9.11122 11.4442 9.11122C11.5276 9.11122 11.5831 9.08344 11.6387 9.00011C11.6387 8.97233 11.6387 8.94455 11.6387 8.94455C11.6387 8.91677 11.6109 8.91677 11.6109 8.889C11.3887 8.61122 11.1387 8.33344 10.9164 8.05566C10.8609 7.97233 10.7498 7.97233 10.6942 8.05566C10.472 8.33344 10.222 8.61122 9.99978 8.889C9.97201 8.91677 9.97201 9.00011 9.97201 9.02789C9.99978 9.05566 10.0553 9.08344 10.1109 9.11122C10.1664 9.11122 10.2498 9.11122 10.3053 9.11122C10.1387 9.97233 9.24978 10.6668 8.41645 10.7501C8.41645 9.55566 8.41645 8.36122 8.41645 7.16677C8.44423 7.16677 8.47201 7.16677 8.49978 7.16677C8.86089 7.16677 9.22201 7.16677 9.58312 7.16677C9.74978 7.16677 9.77756 7.11122 9.77756 6.97233C9.77756 6.83344 9.77756 6.69455 9.77756 6.52789C9.77756 6.36122 9.72201 6.33344 9.58312 6.33344C9.22201 6.33344 8.86089 6.33344 8.49978 6.33344C8.47201 6.33344 8.44423 6.33344 8.38867 6.33344C8.38867 6.22233 8.38867 6.139 8.38867 6.05566C8.38867 6.00011 8.38867 5.97233 8.44423 5.94455C8.61089 5.86122 8.72201 5.75011 8.83312 5.61122C9.27756 5.02789 9.08312 4.22233 8.41645 3.91678C8.30534 3.86122 8.19423 3.83344 8.08312 3.80566C8.05534 3.83344 7.94423 3.83344 7.86089 3.83344ZM7.99978 4.52789C8.22201 4.52789 8.41645 4.69455 8.41645 4.94455C8.41645 5.16678 8.22201 5.36122 7.99978 5.36122C7.77756 5.36122 7.58312 5.16678 7.58312 4.94455C7.58312 4.69455 7.77756 4.52789 7.99978 4.52789Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_494_112355">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StationIcon = ({ type }: { type?: 'load' | 'unload' }) => {
  const fill = type === 'load' ? 'black' : '#1E64DC';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_494_113848)">
        <path
          d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z"
          fill={fill}
        />
        <path
          d="M3.99805 10V5.25C3.99805 4.80833 4.11263 4.45625 4.3418 4.19375C4.57096 3.93125 4.87305 3.73125 5.24805 3.59375C5.62305 3.45625 6.05013 3.36458 6.5293 3.31875C7.00846 3.27292 7.49805 3.25 7.99805 3.25C8.54805 3.25 9.0668 3.27292 9.5543 3.31875C10.0418 3.36458 10.4668 3.45625 10.8293 3.59375C11.1918 3.73125 11.4772 3.93125 11.6855 4.19375C11.8939 4.45625 11.998 4.80833 11.998 5.25V10C11.998 10.4917 11.8293 10.9062 11.4918 11.2438C11.1543 11.5813 10.7397 11.75 10.248 11.75L10.998 12.5V12.75H9.99805L8.99805 11.75H6.99805L5.99805 12.75H4.99805V12.5L5.74805 11.75C5.25638 11.75 4.8418 11.5813 4.5043 11.2438C4.1668 10.9062 3.99805 10.4917 3.99805 10ZM7.99805 4.25C7.11471 4.25 6.46888 4.30208 6.06055 4.40625C5.65221 4.51042 5.37305 4.625 5.22305 4.75H10.823C10.698 4.60833 10.4293 4.48958 10.0168 4.39375C9.6043 4.29792 8.93138 4.25 7.99805 4.25ZM4.99805 7.25H7.49805V5.75H4.99805V7.25ZM10.248 8.25H4.99805H10.998H10.248ZM8.49805 7.25H10.998V5.75H8.49805V7.25ZM6.24805 10.25C6.46471 10.25 6.64388 10.1792 6.78555 10.0375C6.92721 9.89583 6.99805 9.71667 6.99805 9.5C6.99805 9.28333 6.92721 9.10417 6.78555 8.9625C6.64388 8.82083 6.46471 8.75 6.24805 8.75C6.03138 8.75 5.85221 8.82083 5.71055 8.9625C5.56888 9.10417 5.49805 9.28333 5.49805 9.5C5.49805 9.71667 5.56888 9.89583 5.71055 10.0375C5.85221 10.1792 6.03138 10.25 6.24805 10.25ZM9.74805 10.25C9.96471 10.25 10.1439 10.1792 10.2855 10.0375C10.4272 9.89583 10.498 9.71667 10.498 9.5C10.498 9.28333 10.4272 9.10417 10.2855 8.9625C10.1439 8.82083 9.96471 8.75 9.74805 8.75C9.53138 8.75 9.35221 8.82083 9.21055 8.9625C9.06888 9.10417 8.99805 9.28333 8.99805 9.5C8.99805 9.71667 9.06888 9.89583 9.21055 10.0375C9.35221 10.1792 9.53138 10.25 9.74805 10.25ZM5.74805 10.75H10.248C10.4647 10.75 10.6439 10.6792 10.7855 10.5375C10.9272 10.3958 10.998 10.2167 10.998 10V8.25H4.99805V10C4.99805 10.2167 5.06888 10.3958 5.21055 10.5375C5.35221 10.6792 5.53138 10.75 5.74805 10.75ZM7.99805 4.75H10.823H5.22305H7.99805Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_494_113848">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 1 16 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const getIconFromActivity = (activity: string) => {
  switch (activity) {
    case 'load':
      return <IconLoad />;
    case 'unload':
      return <IconUnload />;
    case 'airport':
      return <AirportIcon />;
    case 'airport_of_loading':
      return <AirportIcon type="load" />;
    case 'airport_of_delivery':
      return <AirportIcon type="unload" />;
    case 'port':
      return <PortIcon />;
    case 'port_of_loading':
    case 'port_of_load':
      return <PortIcon type="load" />;
    case 'port_of_delivery':
      return <PortIcon type="unload" />;
    case 'station':
      return <StationIcon />;
    case 'station_of_loading':
    case 'station_of_load':
      return <StationIcon type="load" />;
    case 'station_of_delivery':
      return <StationIcon type="unload" />;
    case 'container':
      return <ContainerIcon />;
    default:
      return <></>;
  }
};

const LocationLogSteps = ({
  t,
  data,
  podFiles = [],
  isPhoneSize,
  showIconExpand,
  showTag,
  showLoadDateAndCity,
  showDocument,
  openModal,
  loadUnloadDate,
  titleSmall,
  addressXSmall,
  customMaxWidth,
}: TLocationLogSteps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const origin = data?.[0];
  const destination = data?.[data.length - 1];

  const additionalRoutes = data?.slice(1, -1);

  const convertMeterToKm = (meter: number) => {
    if (!meter) {
      return '';
    }

    const km = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })?.format(meter / 1000);

    return `${km} km`;
  };

  return (
    <ProgressSteps
      current={data?.length}
      alwaysShowDescription
      overrides={{
        Root: {
          style: {
            maxWidth: customMaxWidth,
            marginBottom: '0px',
            padding: '0px',
            position: 'relative',
            left: '-20px !important',
            marginTop: isPhoneSize ? '8px' : 0,
          },
        },
        IconContainer: { style: { marginTop: '8px' } },
        Title: {
          style: { padding: '0px', lineHeight: '16px', fontSize: '14px' },
        },
        Description: { style: { marginTop: '8px' } },
      }}
    >
      {/* Origin */}
      <Step
        key={origin?.locationId}
        title={
          <>
            {showTag && (
              <Tag
                customClass="mb-2"
                content={t(origin?.activityLabel || origin?.activity || '')}
              />
            )}
            {titleSmall ? (
              <LabelSmall>{origin?.locationName}</LabelSmall>
            ) : (
              <LabelMedium>{origin?.locationName}</LabelMedium>
            )}
          </>
        }
        overrides={{
          Icon: {
            component: origin?.activity === 'load' ? IconLoad : IconUnload,
          },
          IconContainer: {
            style: {
              width: '24px',
              height: '24px',
              margin: '0px 0px 0px 20px',
            },
          },
          Title: {
            style: {
              fontSize: titleSmall ? '14px' : '16px',
              fontWeight: 500,
              padding: 0,
            },
          },
          Tail: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            component: (props: any) => (
              <StyledContentTail
                {...props}
                style={{
                  marginTop: '24px',
                  backgroundColor: '#DDDDDD',
                }}
              >
                <div
                  className="h-full text-center relative !right-[24px]"
                  style={{
                    writingMode: 'vertical-rl',
                    transform: 'rotate(-180deg)',
                  }}
                >
                  <ParagraphXSmall className="text-[10px] !text-[#A6A6A6] mt-6">
                    {convertMeterToKm(origin?.distanceToNextRouteLocation)}
                  </ParagraphXSmall>
                </div>
                {props.children}
              </StyledContentTail>
            ),
          },
        }}
      >
        {addressXSmall ? (
          <ParagraphXSmall className="text-[#5E5E5E]">
            {origin?.locationAddress}
          </ParagraphXSmall>
        ) : (
          <ParagraphSmall className="text-[#5E5E5E]">
            {origin?.locationAddress}
          </ParagraphSmall>
        )}
        {showDocument && origin?.activityFiles?.length > 0 && (
          <ParagraphXSmall
            overrides={{ Block: { style: { color: '#1E64DC' } } }}
            onClick={() =>
              openModal('ModalCarousel', { documents: origin?.activityFiles })
            }
            className={`cursor-pointer flex mt-6`}
          >
            {t('see_load_doc')}
          </ParagraphXSmall>
        )}
        {showLoadDateAndCity && (
          <FlexGrid flexGridColumnCount={2} className="mt-4">
            <FlexGridItem>
              <div>
                <ParagraphXSmall className="!text-[#5E5E5E]">
                  {t('load_estimation')}
                </ParagraphXSmall>
                <ParagraphSmall>
                  {formatDateToLocal(
                    loadUnloadDate?.loadDate || '',
                    'dd MMM yyyy, HH:mm'
                  )}
                </ParagraphSmall>
              </div>
            </FlexGridItem>
            <FlexGridItem>
              <div>
                <ParagraphXSmall className="!text-[#5E5E5E]">
                  {t('city_or_subdistrict')}
                </ParagraphXSmall>
                <ParagraphSmall>{`${origin?.district || ''}, ${
                  origin?.city || ''
                }`}</ParagraphSmall>
              </div>
            </FlexGridItem>
          </FlexGrid>
        )}
        {data && data?.length > 2 && (
          <ParagraphXSmall
            overrides={{ Block: { style: { color: '#276EF1' } } }}
            onClick={() => setIsExpanded(!isExpanded)}
            className={`cursor-pointer ${showIconExpand ? 'flex mt-6' : ''}`}
          >
            {t(isExpanded ? 'close_route_completely' : 'open_route_completely')}
            {showIconExpand && (
              <div>
                {isExpanded ? (
                  <ChevronUpIcon width={20} height={20} />
                ) : (
                  <ChevronDownIcon width={20} height={20} />
                )}
              </div>
            )}
          </ParagraphXSmall>
        )}
      </Step>

      {isExpanded &&
        additionalRoutes?.map((route: DynamicObject) => (
          <Step
            key={route?.locationId}
            title={
              <>
                {showTag && (
                  <Tag
                    content={t(route.activityLabel || route.activity || '')}
                  />
                )}
                {titleSmall ? (
                  <LabelSmall className="mt-2">
                    {route?.locationName}
                  </LabelSmall>
                ) : (
                  <LabelMedium className="mt-2">
                    {route?.locationName}
                  </LabelMedium>
                )}
              </>
            }
            overrides={{
              Icon: {
                component: () =>
                  getIconFromActivity(route?.activityLabel || route?.activity),
              },
              IconContainer: {
                style: {
                  width: '24px',
                  height: '24px',
                  margin: '0px 0px 0px 20px',
                },
              },
              Title: {
                style: {
                  fontSize: titleSmall ? '14px' : '16px',
                  fontWeight: 500,
                  padding: 0,
                  color: '#5E5E5E',
                },
              },
              Tail: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                component: (props: any) => (
                  <StyledContentTail
                    {...props}
                    style={{
                      marginTop: '24px',
                      backgroundColor: '#DDDDDD',
                    }}
                  >
                    <div
                      className="h-full text-center relative !right-[24px]"
                      style={{
                        writingMode: 'vertical-rl',
                        transform: 'rotate(-180deg)',
                      }}
                    >
                      <ParagraphXSmall className="text-[10px] !text-[#A6A6A6] mt-6">
                        {convertMeterToKm(route?.distanceToNextRouteLocation)}
                      </ParagraphXSmall>
                    </div>
                    {props.children}
                  </StyledContentTail>
                ),
              },
            }}
          >
            {addressXSmall ? (
              <ParagraphXSmall className="text-[#5E5E5E]">
                {route?.locationAddress}
              </ParagraphXSmall>
            ) : (
              <ParagraphSmall className="text-[#5E5E5E]">
                {route?.locationAddress}
              </ParagraphSmall>
            )}
            {showDocument && route?.activityFiles?.length > 0 && (
              <ParagraphXSmall
                overrides={{ Block: { style: { color: '#1E64DC' } } }}
                onClick={() =>
                  openModal('ModalCarousel', {
                    documents: route?.activityFiles,
                  })
                }
                className={`cursor-pointer flex mt-6`}
              >
                {route?.activity === 'load'
                  ? t('see_load_doc')
                  : t('see_unload_doc')}
              </ParagraphXSmall>
            )}
            {showLoadDateAndCity && (
              <FlexGrid flexGridColumnCount={2} className="mt-4">
                <FlexGridItem>
                  <div>
                    <ParagraphXSmall className="!text-[#5E5E5E]">
                      {route?.activity === 'load'
                        ? t('load_estimation')
                        : t('unload_estimation')}
                    </ParagraphXSmall>
                    <ParagraphSmall>
                      {formatDateToLocal(
                        route.eta || '',
                        'dd MMM yyyy, HH:mm'
                      ) || '-'}
                    </ParagraphSmall>
                  </div>
                </FlexGridItem>
                <FlexGridItem>
                  <div>
                    <ParagraphXSmall className="!text-[#5E5E5E]">
                      {t('city_or_subdistrict')}
                    </ParagraphXSmall>
                    <ParagraphSmall>{`${route?.district || ''}, ${
                      route?.city || ''
                    }`}</ParagraphSmall>
                  </div>
                </FlexGridItem>
              </FlexGrid>
            )}
          </Step>
        ))}

      {/* Destination */}
      <Step
        key={destination?.locationId}
        title={
          <>
            {showTag && (
              <Tag
                content={t(
                  destination?.activityLabel || destination?.activity || ''
                )}
              />
            )}
            {titleSmall ? (
              <LabelSmall className="mt-2">
                {destination?.locationName}
              </LabelSmall>
            ) : (
              <LabelMedium className="mt-2">
                {destination?.locationName}
              </LabelMedium>
            )}
          </>
        }
        overrides={{
          Icon: {
            component: destination?.activity === 'load' ? IconLoad : IconUnload,
          },
          IconContainer: {
            style: {
              width: '24px',
              height: '24px',
              margin: '0px 0px 0px 20px',
            },
          },
          Title: {
            style: {
              fontSize: titleSmall ? '14px' : '16px',
              fontWeight: 500,
              padding: 0,
              color: '#5E5E5E',
            },
          },
          Tail: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            component: (props: any) => (
              <StyledContentTail
                {...props}
                style={{
                  marginTop: '24px',
                  backgroundColor: '#DDDDDD',
                }}
              >
                <div
                  className="h-full text-center relative !right-[24px]"
                  style={{
                    writingMode: 'vertical-rl',
                    transform: 'rotate(-180deg)',
                  }}
                >
                  <ParagraphXSmall className="text-[10px] !text-[#A6A6A6] mt-6">
                    {convertMeterToKm(destination?.distanceToNextRouteLocation)}
                  </ParagraphXSmall>
                </div>
                {props.children}
              </StyledContentTail>
            ),
          },
        }}
      >
        {addressXSmall ? (
          <ParagraphXSmall className="text-[#5E5E5E]">
            {destination?.locationAddress}
          </ParagraphXSmall>
        ) : (
          <ParagraphSmall className="text-[#5E5E5E]">
            {destination?.locationAddress}
          </ParagraphSmall>
        )}
        {showDocument && (
          <div className="flex gap-2">
            {destination?.activityFiles?.length > 0 && (
              <ParagraphXSmall
                overrides={{ Block: { style: { color: '#1E64DC' } } }}
                onClick={() =>
                  openModal('ModalCarousel', {
                    documents: destination?.activityFiles,
                  })
                }
                className={`cursor-pointer flex mt-6`}
              >
                {t('see_unload_doc')}
              </ParagraphXSmall>
            )}
            {destination?.activityFiles?.length > 0 &&
              podFiles &&
              podFiles?.length > 0 && (
                <ParagraphXSmall
                  overrides={{ Block: { style: { color: '#E8E8E8' } } }}
                  className="flex mt-6"
                >
                  |
                </ParagraphXSmall>
              )}
            {podFiles && podFiles?.length > 0 && (
              <ParagraphXSmall
                overrides={{ Block: { style: { color: '#1E64DC' } } }}
                onClick={() =>
                  openModal('ModalCarousel', { documents: podFiles })
                }
                className={`cursor-pointer flex mt-6`}
              >
                {t('see_pod_doc')}
              </ParagraphXSmall>
            )}
          </div>
        )}
        {showLoadDateAndCity && (
          <FlexGrid flexGridColumnCount={2} className="mt-4">
            <FlexGridItem>
              <div>
                <ParagraphXSmall className="!text-[#5E5E5E]">
                  {t('unload_estimation')}
                </ParagraphXSmall>
                <ParagraphSmall>
                  {formatDateToLocal(
                    loadUnloadDate?.unloadDate || '',
                    'dd MMM yyyy, HH:mm'
                  )}
                </ParagraphSmall>
              </div>
            </FlexGridItem>
            <FlexGridItem>
              <div>
                <ParagraphXSmall className="!text-[#5E5E5E]">
                  {t('city_or_subdistrict')}
                </ParagraphXSmall>
                <ParagraphSmall>{`${destination?.district || ''}, ${
                  destination?.city || ''
                }`}</ParagraphSmall>
              </div>
            </FlexGridItem>
          </FlexGrid>
        )}
      </Step>
    </ProgressSteps>
  );
};

export default withErrorBoundary(memo(LocationLogSteps));
